import { Modal, Button } from "react-bootstrap";
import { ExclamationTriangleFill } from "react-bootstrap-icons"; // 아이콘

const SessionExpiryModal = ({ show, onConfirm }) => {
  return (
    <Modal
      show={show}
      onHide={onConfirm}
      centered
      backdrop="static"
      keyboard={false}
      className="fade session-expiry-modal"
    >
      <Modal.Header className="bg-warning text-white" closeButton>
        <Modal.Title>
          <ExclamationTriangleFill className="me-2" />
          세션 만료 안내
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center fs-5">
        로그인 세션이 만료되었습니다. <br />
        다시 로그인 해주시기 바랍니다.
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button variant="dark" size="lg" onClick={onConfirm}>
          확인하고 로그인하기
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SessionExpiryModal;
